export default "__VITE_ASSET__xpIyzj0l__"